import React from 'react';
import { Switch, Route } from 'react-router-dom';
import LeadsCreation from './LeadCreation/LeadCreationContainer';
import LeadsList from './LeadsList';
import LeadDetails from './LeadDetails';

const Routes = (): React.JSX.Element => (
  <Switch>
    <Route exact path="/leads">
      <LeadsList />
    </Route>
    <Route exact path="/leads-create">
      <LeadsCreation />
    </Route>
    <Route exact path="/leads/create">
      <LeadsCreation />
    </Route>
    <Route path="/leads/:id">
      <LeadDetails />
    </Route>
  </Switch>
);

export default Routes;
